module.exports = __webpack_public_path__ + "Card2-Ethnography.png?0151c9ca931a3f4e343af4015abb4048";


//////////////////
// WEBPACK FOOTER
// ./static/Card2-Ethnography.png
// module id = 343
// module chunks = 0